import {defineComponent, DataTable} from "../../../src";
import Variables from "./Variables";

defineComponent(DataTable.componentName, DataTable, 'example');
defineComponent(Variables.componentName, Variables, 'example');

